import type { FlowNode, FlowNodeResultADT } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

export const handleCloseFloat = (node: FlowNode, params: ExecuteActionParams): Promise<undefined | FlowNodeResultADT> => {
    const { actionEvents } = params
    actionEvents.closeFloat()

    return Promise.resolve({
        type: 'record',
        success: true
    })
}
